import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import NotAccessPage from './NotAccessPage'
import { useMutation } from '@apollo/client'
import { SIGNIN_BY_TOKEN } from '../query/userQuery'
import { AUTH_TOKEN } from '../constants'

const PrivateRoute = ({
  render,
  isAuthenticated,
  isAuthorized,
  darkMode,
  ...routeProps
}) => {
  const [signInByToken] = useMutation(SIGNIN_BY_TOKEN, {
    onError (err) {
      console.error(err)
      window.location.href = '/'
    }
  })

  useEffect(() => {
    if (isAuthenticated) {
      signInByToken({ variables: { token: window.localStorage.getItem(AUTH_TOKEN) } })
    }
  }, [isAuthenticated])

  return (
    <Route
      {...routeProps}
      render={props => {
        if (!isAuthenticated) {
          return <NotAccessPage darkMode={darkMode} />
        }

        if (!isAuthorized) {
          return <NotAccessPage darkMode={darkMode} />
        }

        return render(props)
      }}
    />
  )
}

export default PrivateRoute